import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/solid';
import { debounce } from '../../utils/helpers';

const SearchBar = ({ filters, onFilterChange }) => {
  const handleSearchChange = debounce((value) => {
    onFilterChange({ search: value });
  }, 300);

  return (
    <div className="mb-6 space-y-4">
      {/* Global Search */}
      <div className="relative">
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
        </div>
        <input
          type="text"
          className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
          placeholder="Search all research outputs..."
          onChange={(e) => handleSearchChange(e.target.value)}
          defaultValue={filters.search}
        />
      </div>

      {/* Advanced Filters */}
      <div className="flex flex-wrap gap-4">
        <select
          className="block w-48 pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
          value={filters.year}
          onChange={(e) => onFilterChange({ year: e.target.value })}
        >
          <option value="">All Years</option>
          {Array.from({ length: 11 }, (_, i) => 2013 + i).map(year => (
            <option key={year} value={year}>{year}</option>
          ))}
        </select>

        <select
          className="block w-48 pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-md"
          value={filters.outputType}
          onChange={(e) => onFilterChange({ outputType: e.target.value })}
        >
          <option value="">All Output Types</option>
          <option value="Article">Article</option>
          <option value="PhD thesis">PhD thesis</option>
          <option value="Research project">Research project</option>
          <option value="Report">Report</option>
          <option value="Editorial">Editorial</option>
          <option value="Book">Book</option>
          <option value="Letter">Letter</option>
        </select>

        <button
          className="inline-flex items-center px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500"
          onClick={() => onFilterChange({
            search: '',
            year: '',
            outputType: ''
          })}
        >
          Clear Filters
        </button>
      </div>
    </div>
  );
};

export default SearchBar;